export default "__VITE_ASSET__D$bngg0y__"